<template>
  <b-container fluid>
    <div class="content-card">
      <page-header title="Productividad Comercial" @back="volverAtras" />

      <FiltrosOfertas @filtrar="filtrosCambiados" />
      <GraficaActividad :items="items" />
      <GraficaProductividad :items="items" />
      <GraficaARR :items="items" />
      <TablaAnalisisComercial :items="items" />
    </div>
  </b-container>
</template>

<script>
import FiltrosOfertas from "@/views/ofertas/Listar/FiltrosOfertas.vue";
import { useFiltrosOfertaFormStore } from "@/stores/FiltrosOfertaForm";
import { tablaProductividadComercial } from "@/services/productividadComercial.js";
import TablaAnalisisComercial from "./TablaAnalisisComercial.vue";
import GraficaActividad from "./GraficaActividad.vue";
import GraficaARR from "./GraficaARR.vue";
import GraficaProductividad from "./GraficaProductividad.vue";

export default {
  components: {
    FiltrosOfertas,
    GraficaActividad,
    GraficaARR,
    GraficaProductividad,
    TablaAnalisisComercial,
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    volverAtras() {
      this.$router.push("/ofertas");
    },
    async actualizarDatos() {
      const filtrosOfertaFormStore = useFiltrosOfertaFormStore();
      const params = Object.assign({}, filtrosOfertaFormStore.filtrosAplicables);
      const items = await tablaProductividadComercial(params);

      const totalArr = items.reduce((sum, item) => sum + item.arr, 0);
      items.forEach((item) => {
        item.contribucionARR = totalArr ? (item.arr * 100) / totalArr : 0;
      });

      this.items = items;
    },
    filtrosCambiados() {
      this.actualizarDatos();
    },
  },
  async mounted() {
    const filtrosOfertaFormStore = useFiltrosOfertaFormStore();
    await filtrosOfertaFormStore.actualizarFiltrosAplicables();
    await this.actualizarDatos();
  },
};
</script>
